const blocks = [
  {
    title: "Data we store",
    body:
      "Basic guild and community metadata plus your submission details. We do not store member-level personal data."
  },
  {
    title: "Cookies",
    body:
      "The MVP uses standard analytics only to understand traffic. No behavioral advertising, tracking pixels, or third-party ad networks."
  },
  {
    title: "Contact",
    body:
      "For privacy requests email hello@memberdiscovery.com with the subject line PRIVACY REQUEST."
  }
];

const Privacy = () => (
  <div className="space-y-6">
    <p className="text-xs uppercase tracking-[0.3em] text-brand-secondary">Privacy Policy</p>
    <h1 className="text-4xl text-slate-100">How we treat your data</h1>
    <section className="panel space-y-4 text-sm text-slate-300">
      {blocks.map((block) => (
        <article key={block.title} className="space-y-2">
          <h2 className="text-xl text-slate-100">{block.title}</h2>
          <p>{block.body}</p>
        </article>
      ))}
      <p className="text-xs text-slate-500">
        Placeholder policy text for the MVP. Replace with full legal copy before launch.
      </p>
    </section>
  </div>
);

export default Privacy;
